export default "__VITE_ASSET__BkShXx3t__"